import React from "react";
import cx from "classnames";
import * as styles from "./SameGameMultiPill.module.scss";
import { ReactComponent as SGMIcon } from "components/layout/assets/icon-sgm.svg";

type SameGameMultiPillProps = { className?: string };

export const SameGameMultiPill = ({ className }: SameGameMultiPillProps) => {
  return (
    <div className={cx(styles.sgmPill, className)}>
      <SGMIcon />
    </div>
  );
};
